import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IButton } from '@interfaces/elements';
import { IServerResponse } from '@interfaces/server';
import { GerarPlanilhaDadosService } from '@services/gerar-planilha-dados.service';
import { ParametroSistemaService } from '@services/parametro-sistema.service';
import { interval, Subscription } from 'rxjs';
import { exhaustMap, finalize, retry, tap } from 'rxjs/operators';
import { LocalStorageDecorator } from 'src/app/libs/local-storage-decorator';
import { GoogleComponent } from '@pages/utils/google.component';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'app-lateral-importador-pedidos',
    templateUrl: './lateral-importador-pedidos.component.html',
    styleUrls: ['./lateral-importador-pedidos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, TagManagerDirective]
})
export class LateralImportadorPedidosComponent extends GoogleComponent implements OnInit, OnDestroy {
  loadingGenerico: boolean;
  public empresa: any = localStorage.idEmpresaLogada;
  @LocalStorageDecorator() idDownload: string;
  loadingGenericoMessage: string;
  falhaPesquisa: boolean;
  fileNamePending: any;
  subscriptions = new Subscription();
  public loadingGenericoData = { buttons: [] as Array<IButton> };
  public tipoArquivo: any;
  public urlManualTxt = '/assets/documentos/Layout_VT_V8.pdf';

  private readonly sectionApp = 'importacao-realizacao-pedidos';
  private readonly screenName = 'importacao-realizacao-pedidos:home';
  private readonly screenType = 'pagina';

  constructor(
    private readonly gerarPlanilhaDadosService: GerarPlanilhaDadosService,
    private readonly parametroService: ParametroSistemaService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.idDownload) {
      this.watchFileGenerationStatus();
    }
    this.parametroService.getParametroSistema('CNPJ_ALFANUMERICO_ATIVO').subscribe(
      (dados: any) => {
        if (dados?.response !== 'S') {
          this.urlManualTxt = '/assets/documentos/Layout_VT_V7.pdf';
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }

  abreFechaAccordion(idAccordion: string) {
    const accordion = document.getElementById(idAccordion).getElementsByClassName('expansive')[0];
    const icone = document.getElementById(idAccordion).getElementsByClassName('icone')[0];
    if (accordion.classList.contains('d-none')) {
      accordion.classList.remove('d-none');
      icone.classList.remove('fa-angle-down');
      icone.classList.add('fa-angle-up');
    } else {
      accordion.classList.add('d-none');
      icone.classList.remove('fa-angle-up');
      icone.classList.add('fa-angle-down');
    }
  }

  startFileGeneration(tipoArquivo: any) {
    this.tipoArquivo = tipoArquivo;
    this.loadingGenerico = true;
    const params = this.getParamsFormatArray(this.tipoArquivo);
    const paramsUrl = params.map(p => `${p.name}${p.comparator}${p.value}`).join('&');
    const paramsUrlFinal = paramsUrl ? `?${paramsUrl}` : '';

    this.gerarPlanilhaDadosService.startFileGeneration(this.empresa, paramsUrlFinal)
      .pipe(finalize(() => this.watchFileGenerationStatus()))
      .subscribe({
        next: ({ response: { idDownload } }) => {
          this.idDownload = idDownload;
          this.loadingGenericoMessage = 'Por favor, aguarde enquanto seu arquivo é gerado...';
        },
        error: () => {
          this.loadingGenericoMessage = 'Já existe uma planilha sendo gerada, aguarde enquanto recuperamos essas informações...';
        }
      });
  }

  private watchFileGenerationStatus() {
    this.loadingGenerico = true;
    const subscription = interval(1000)
      .pipe(
        exhaustMap(() => this.gerarPlanilhaDadosService
          .getFileGenerationStatus(this.idDownload, this.tipoArquivo)
          .pipe(retry(10)),
        ),
        tap(({ response }: IServerResponse) => {
          const endedFileGeneration = ['ERRO', 'FINALIZADO'].includes(response?.status);
          if (endedFileGeneration) {
            this.loadingGenericoData.buttons.length = 0;
          } else {
            this.loadingGenericoData.buttons[0] = {
              content: 'Cancelar',
              ngClass: 'btn btn-danger',
              click: (e) => {
                e.preventDefault();
                subscription.unsubscribe();
                this.loadingGenericoData.buttons.length = 0;
                this.loadingGenerico = false;
                this.idDownload = undefined;
              },
            };
          }
        }),
      )
      .subscribe(({ response }) => {
        this.loadingGenerico = true;
        if (!response?.status || response?.status === 'ERRO') {
          this.idDownload = undefined;
          this.loadingGenericoMessage = null;
          this.falhaPesquisa = true;
          this.loadingGenerico = false;
          subscription.unsubscribe();
        } else if (response?.status === 'FINALIZADO') {
          this.fileNamePending = response?.nomeArquivo;
          this.loadingGenericoMessage = null;
          this.loadingGenerico = false;
          this.idDownload = undefined;
          window.open(response?.urlDownload);
          subscription.unsubscribe();
        } else {
          this.loadingGenericoMessage = 'Por favor, aguarde enquanto o arquivo é gerado...';
        }
      });
    this.subscriptions.add(subscription);
  }

  getParamsFormatArray(tipoArquivo: any) {
    return [
      { name: 'flagAtivos', comparator: '=', value: 'S' },
      { name: 'idDepart', comparator: '=', value: 0 },
      { name: 'idEndere', comparator: '=', value: 0 },
      { name: 'tipo', comparator: '=', value: tipoArquivo }
    ];
  }

}
